import { createSelector } from 'reselect'
import StoreState from 'store/state'

const externalServicesSelector = (state: StoreState) => state.external

export const facebookSDKInitializedSelector = createSelector(externalServicesSelector, (external) => external.facebook.initialized)
export const twitterSDKInitializedSelector = createSelector(externalServicesSelector, (external) => external.twitter.initialized)
